import React from 'react';
import Paper from '@material-ui/core/Paper';
import {displayCost, displayUsage} from '../../../../helpers/helper';
import { USAGE_TYPE, UNITS } from '../../../../constants/common';

export default function BillProjection(props) {
  const displayValue = props.configs.data['billprojection.displayValue'];
  const usageValue = (displayValue === USAGE_TYPE.COST ? 
    (displayCost({cost: (props.billProjectionData && props.billProjectionData.currentPrice ? props.billProjectionData.currentPrice : 0), round: true, showCurrency:true })) : 
    displayUsage({usage: (props.billProjectionData && props.billProjectionData.currentConsumption ? props.billProjectionData.currentConsumption : 0), round: true, showUsageUnit: true, fuelType: props.configs.data.fuelType }));
  const projectedUsageValue = (displayValue === USAGE_TYPE.COST ? 
    (displayCost({cost: (props.billProjectionData && props.billProjectionData.projectionPrice ? props.billProjectionData.projectionPrice : 0), round: true, showCurrency:true })) : 
    displayUsage({usage: (props.billProjectionData && props.billProjectionData.projectionConsumption ? props.billProjectionData.projectionConsumption : 0), round: true, showUsageUnit: true, fuelType: props.configs.data.fuelType }));

  return(
    <Paper className="bp-and-usage-summary-widget bill-projection-container">
      <div className="summary-header-container">
        <div className="summary-header-title">
          <span className="summary-title-main">{props.translations["HOME.BILL_PROJECTION.PROJECTED_BILL"]}</span>
          <span className="bill-period">
            {props.billProjectionData && props.billProjectionData.billStartDate && props.billProjectionData.billEndDate && (
              <>
                {props.billProjectionData.billStartDate} - {props.billProjectionData.billEndDate}
              </>
            )}
            ({props.translations["HOME.BILL_PROJECTION.CURRENT_PERIOD"]})
            </span>
        </div>
      </div>
      <div className="summary-container">
        <div className="usage">
          <span className="summary-title">{props.translations["HOME.BILL_PROJECTION.USAGE_SO_FAR"]}</span>
          <span className="usage-value">{usageValue}</span>
        </div>
        <div className="usage">
          <span className="summary-title">{props.translations["HOME.BILL_PROJECTION.PROJECTED"]}</span>
          <span className="usage-value">{projectedUsageValue}</span>
        </div>
        <div className="usage">
          <span className="summary-title">{props.translations["HOME.BILL_PROJECTION.DAYS_LEFT"]}</span>
          <span className="usage-value">{props.billProjectionData && props.billProjectionData ? props.billProjectionData.daysLeft : 0} {props.translations["HOME.BILL_PROJECTION.DAYS"]}</span>
        </div>
      </div>
      {props.billProjectionError && (
        <div className="home-api-error">{props.translations["HOME.BILL_PROJECTION.API_ERROR"]}</div>
      )}
    </Paper>
  );
}
